import React, {useEffect} from "react";
import {useStyles} from "../../../components/styles/ComponentsStyle";
import {
    Box,
    IconButton,
    Tabs,
    Tab,
    TextField, InputAdornment
} from "@material-ui/core";
import PropTypes from 'prop-types';
import { ReactComponent as VolumeDisableIcon } from '../../../../../common/images/VolumeDisableIcon.svg';
import { ReactComponent as Refresh } from '../../../../../common/images/RefreshIcon.svg';
import { ReactComponent as RefreshDisabled } from '../../../../../common/images/RefreshDisableIcon.svg';
import {inject, observer} from "mobx-react";
import {ReactComponent as VolumeIcon} from "../../../../../common/images/VolumeIcon.svg";
import {VoiceType} from "../../../../../common/enums/VoiceType";


function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <div>{children}</div>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

function OddStepFour(props) {
    const classes = useStyles();

    const {contentStore,oddStepFourStore} = props;
    const {stepValue, dayValue} = props.contentStore;

    const handleChange = (event, newValue) => {
        oddStepFourStore.setContentTapIndex(newValue);
    };

    const onSave = () => {
        oddStepFourStore.modifyOddStepFourContent(stepValue, dayValue, () => {
            oddStepFourStore.getOddStepFourContent(stepValue, dayValue, processOddStepFourContent);
            contentStore.setReadyToSaveStep(false);
        });
    }

    const processOddStepFourContent = (res) => {
        const isCompleted = oddStepFourStore.isOddStepFourCompleted(res);
        contentStore.setReadyToMoveExit(isCompleted);
    }

    useEffect(() => {
        oddStepFourStore.getOddStepFourContent(stepValue, dayValue, processOddStepFourContent)
        contentStore.setOnSave(onSave);
        return ()=> {
            contentStore.setOnSave(null);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleChangeText = (content, event) => {
        oddStepFourStore.changeText(content, event.target.value);
        if (content.text !== oddStepFourStore.getRefreshable(content.id).text) {
            oddStepFourStore.changeRefreshable(content.id, true);
        } else {
            oddStepFourStore.changeRefreshable(content.id, false, content.text);
        }

        contentStore.setReadyToSaveStep(oddStepFourStore.isChangeContent());
    }

    const handleClickAudio = (id) => {
        oddStepFourStore.playAudio(id);
    }

    const handleRefreshTTS = (content) => {
        oddStepFourStore.stopAudio();
        contentStore.getGeneratedTTSWithGoogle(content.languageCode, VoiceType.MAN, content.text, (audio) => oddStepFourStore.changeContentAudio(content, audio.split(',')[1]));
        oddStepFourStore.changeRefreshable(content.id, false, content.text);
        contentStore.setReadyToSaveStep(true);
    }

    return (
        <div className={classes.root}>
            <Box className={classes.boxWrap}>
                <Box>
                    <Box position="static" className={classes.tabBox}>
                        <Tabs value={oddStepFourStore.contentTapIndex} onChange={handleChange} aria-label="simple tabs example">
                            <Tab label="한국어" {...a11yProps(0)} disableRipple/>
                            <Tab label="영어" {...a11yProps(1)} disableRipple/>
                            <Tab label="일본어" {...a11yProps(2)} disableRipple/>
                            <Tab label="중국어" {...a11yProps(3)} disableRipple/>
                        </Tabs>
                    </Box>
                    {Array.from({length: 4}, (_, i) => (
                        <TabPanel key={i} value={oddStepFourStore.contentTapIndex} index={i} className={classes.textBoxQuiz}>
                            {/*<Box className={classes.textQuizBox} >*/}
                            {/*    <TextField id="outlined-basic" variant="outlined" placeholder="제시어를 입력해 주세요."/>*/}
                            {/*    <Button className={classes.active} disableRipple>*/}
                            {/*        <Typography>생성</Typography>*/}
                            {/*    </Button>*/}
                            {/*</Box>*/}
                            <Box display={'flex'} alignItems={'center'} justifyContent={'flex-start'} className={classes.quizListBox} style={{flexWrap: 'wrap'}}>
                                {oddStepFourStore.contentList && oddStepFourStore.getSelectedContent().map((content, index) => {
                                    const id = content.id;
                                    const isRefreshable = oddStepFourStore.getRefreshable(id)?.isRefreshable;

                                    return (
                                        <Box key={index} display={'flex'} style={{width: '25%', marginBottom: 70}}>
                                            <Box display={'flex'} alignItems={'center'} justifyContent={'space-between'}>
                                                <TextField
                                                    id="outlined-basic"
                                                    placeholder="텍스트를 입력해주세요."
                                                    variant="outlined"
                                                    value={content.text}
                                                    onChange={(event) => handleChangeText(content, event)}
                                                    inputProps={{
                                                        style: {
                                                            textAlign: 'center'
                                                        }
                                                    }}
                                                    InputProps={{
                                                        endAdornment: (
                                                            <InputAdornment position='end'>
                                                                <IconButton className={classes.quizVolume} disableRipple style={{cursor: content.audio === null ? 'default' : 'pointer'}} disabled={content.audio === null} onClick={() => handleClickAudio(id)}>
                                                                    {content.audio !== null ?
                                                                        <VolumeIcon /> :
                                                                        <VolumeDisableIcon />
                                                                    }
                                                                </IconButton>
                                                            </InputAdornment>
                                                        )
                                                    }}
                                                />
                                            </Box>
                                            <IconButton className={classes.quizRefresh} disableRipple disabled={!isRefreshable} onClick={() => handleRefreshTTS(content)}>
                                                {isRefreshable ?
                                                    <Refresh/>
                                                    :
                                                    <RefreshDisabled/>
                                                }
                                            </IconButton>
                                        </Box>
                                    )
                                })}
                            </Box>
                        </TabPanel>
                    ))}
                </Box>
            </Box>
        </div>
    );
}

export default inject('oddStepFourStore', 'contentStore')(observer(OddStepFour))
